module.exports = __webpack_public_path__ + "media/responsive/about-us-35f52298.jpg";